// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__aF3mX","hideOnMobile":"Tooltip_hideOnMobile__nfjVp"};